import { render, staticRenderFns } from "./OverlayBanner.vue?vue&type=template&id=6d66d271&"
import script from "./OverlayBanner.vue?vue&type=script&lang=js&"
export * from "./OverlayBanner.vue?vue&type=script&lang=js&"
import style0 from "./OverlayBanner.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports